<template>
  <div class="home" :style="{ backgroundImage: `url(${data.bgInfo?.icon})` }">
    <div class="boli"></div>
      <HeaderTop :data="data.logoInfo" />
      <div class="homeBox">
          <div class="homeBoxTitle">{{ data.bgInfo?.title }}</div>
          <div class="homeBoxText">
              {{ data.bgInfo?.desc }}
          </div>
      </div>
  </div>
</template>

<script setup>
import HeaderTop from './headerTop.vue'
const props = defineProps({
  data: {
      type: Object,
      default: () => {
          return {}
      }
  }
})
</script>

<style lang="scss" scoped>
.home {
  // background-image: url(https://p5.ssl.qhimg.com/t110b9a9301245986b620df4019.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  // aspect-ratio: 1440 / 632;
  height: 300px;
  position: relative;
  .boli{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(2px);
  }

  &Box {
      width: 100%;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;

      &Title {
          font-family: 360 守护体;
          font-size: 20px;
          font-weight: bold;
          line-height: 36px;
          letter-spacing: 3.75px;
          color: #FFFFFF;
          top: 65px;
      }

      &Text {
        color: rgb(255, 255, 255);
        font-family: Alibaba PuHuiTi 3.0;
        font-size: 16px;
        font-weight: 500;
        top: 75px;
      }
  }
}
</style>
